module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-body-follow"
  }, [_vm._l((_vm.private_community_all), function(item) {
    return [_c('CommunityItem', {
      attrs: {
        "o": item
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10b64dfa","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/Community.vue
// module id = 1487
// module chunks = 0